import { subscriptionId, perpetualId } from "../../graphql/data-id";

const expProps = (expirationDate, now) => ({
	expirationDate,
	isExpired: expirationDate !== null && expirationDate < now,
});

export const createLicense = (
	id,
	dbID,
	productTitle,
	licenseName,
	serialNumbers,
	type,
	expirationDate,
	purchaseDate,
	lastOrder,
	status = "active",
	isAutoBillingEnabled = false,
	isActive = true,
	now,
	isTrial,
) => ({
	__typename: "License",
	id,
	dbID,
	productTitle,
	licenseName,
	serialNumbers,
	type,
	...expProps(expirationDate && new Date(expirationDate), now),
	purchaseDate: new Date(purchaseDate),
	status,
	isAutoBillingEnabled,
	isActive,
	isTrial: isTrial ?? false,
	lastOrder,
});

export const subscriptionToLicence = (now = Date.now()) => ({
	subscriptionID,
	plan,
	serialNumbers,
	expirationDate,
	dateCreated,
	isAutoBillingEnabled,
	status,
	isTrial,
	lastOrder,
}) =>
	createLicense(
		subscriptionId({ subscriptionID }),
		subscriptionID,
		plan.name,
		serialNumbers[0]?.licenseName || "",
		serialNumbers.map(({ serialNumber, id }) => ({ serialNumber, id })),
		"subscription",
		expirationDate,
		dateCreated,
		lastOrder,
		status,
		isAutoBillingEnabled,
		status === "active", // TODO move subscription flags to GraphQL
		now,
		isTrial,
	);

export const perpetualToLicense = ({
	id,
	serialNumber,
	dateCreated,
	licenseName,
	order, // { orderNumber, orderDate }
	product, // { description },
}) =>
	createLicense(
		perpetualId({ id }),
		id,
		product.description,
		licenseName,
		[{ id, serialNumber }],
		"perpetual",
		null,
		order?.orderDate ?? dateCreated,
		order,
	);
